import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
import exportMethod from './export'
import months from './months'
import categories from './categories'
import entries from './entries'
/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::index
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:29
* @route '/profit-loss'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/profit-loss',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::index
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:29
* @route '/profit-loss'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::index
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:29
* @route '/profit-loss'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::index
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:29
* @route '/profit-loss'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::index
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:29
* @route '/profit-loss'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::index
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:29
* @route '/profit-loss'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::index
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:29
* @route '/profit-loss'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

const profitLoss = {
    index: Object.assign(index, index),
    export: Object.assign(exportMethod, exportMethod),
    months: Object.assign(months, months),
    categories: Object.assign(categories, categories),
    entries: Object.assign(entries, entries),
}

export default profitLoss